import React from "react";
import { cn } from "@/lib/utils";

type TabOption<T> = {
  id: T;
  label: string;
};

interface ExploreTabsHeaderProps<T extends string> {
  tabs: TabOption<T>[];
  activeTab: T;
  onTabChange: (tabId: T) => void;
}

export default function ExploreTabsHeader<T extends string>({ 
  tabs, 
  activeTab, 
  onTabChange 
}: ExploreTabsHeaderProps<T>) {
  return (
    <div className="border-b mb-6">
      <div className="flex flex-col sm:flex-row sm:space-x-8 space-y-2 sm:space-y-0">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "pb-2 relative min-h-[44px] flex items-center justify-start sm:justify-center",
              activeTab === tab.id ? "text-foreground" : "text-muted-foreground hover:text-foreground"
            )}
          >
            <h3 className="text-lg font-medium">{tab.label}</h3>
            {activeTab === tab.id && (
              <div className="absolute bottom-0 left-0 w-full h-0.5 bg-primary" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
